import React from "react";

/**
 * Marks a creative that is outside its start/end date window.
 *
 * "Paused" rather than "Expired" because the state is reversible: the row stays
 * in the playlist, and re-dating the creative brings it straight back into
 * rotation. The portal deliberately keeps these rows visible — hiding them
 * would make them impossible to remove or reorder around — so the badge is what
 * tells an operator the item is not currently playing.
 *
 * Playback is enforced server-side, not here; this is only the signal.
 */
const PausedBadge: React.FC<{ className?: string }> = ({ className = "" }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700 ${className}`}
    title="Outside its start/end date range — not playing. Update the dates to resume."
  >
    Paused
  </span>
);

export default PausedBadge;
